import { compose } from 'redux';
import { connect } from 'react-redux';
import { withReducer } from '../../withReducer';
import { reducer } from '../reducer';
import { mapDispatchToProps } from '../container';
import { RenderPreview } from './preview';
import { withSettings } from '../withSettings';
const mapStateToProps = (state, props) => {
    return {
        ...state[props.componentIdent],
        isChecked: !state[props.componentIdent].isHidden,
    };
};
export const RenderPreviewContainer = compose(withReducer(reducer), connect(mapStateToProps, null))(RenderPreview);
export const RenderFormContainer = compose(withReducer(reducer), connect(mapStateToProps, mapDispatchToProps))(withSettings());
//# sourceMappingURL=container.js.map